/**
 * SNS Preview Live Utils
 *
 * Utility helpers for detecting SNS URLs and resolving platform metadata in live previews.
 */

import { SNSPlatform } from "../core/sns-platform";
import { SNSDetector } from "../core/sns-detector";

const detector = new SNSDetector();

export class SNSPreviewLiveUtils {
    /** Detect SNS links from content. */
    public static detectSnsLinks(content: string): string[] {
        return detector.extractUrls(String(content || ""), {
            decodeHtmlEntities: true,
            expandFacebookPluginHref: true,
        });
    }

    /** Return detection metadata for a single URL. */
    public static getUrlMeta(url: string): { platform: string | null; id: string | null; url: string } {
        return detector.detectUrlMeta(String(url || ""));
    }

    /** Resolve the SNS platform for a URL. */
    public static getPlatform(url: string): string | null {
        const detectedPlatform = SNSPreviewLiveUtils.getUrlMeta(url).platform;
        if (detectedPlatform === SNSPlatform.YOUTUBE) return SNSPlatform.YOUTUBE;
        if (detectedPlatform === SNSPlatform.FACEBOOK) return SNSPlatform.FACEBOOK;
        if (detectedPlatform === SNSPlatform.INSTAGRAM) return SNSPlatform.INSTAGRAM;
        if (detectedPlatform === SNSPlatform.X) return SNSPlatform.X;
        if (detectedPlatform === SNSPlatform.TIKTOK) return SNSPlatform.TIKTOK;

        return null;
    }

    /** Get platform icon class for a URL. */
    public static getPlatformIcon(url: string): string {
        const platform = SNSPreviewLiveUtils.getPlatform(url);
        if (platform === SNSPlatform.FACEBOOK) return "bi sns-icon bi-facebook";
        if (platform === SNSPlatform.YOUTUBE) return "bi sns-icon bi-youtube";
        if (platform === SNSPlatform.INSTAGRAM) return "bi sns-icon bi-instagram";
        if (platform === SNSPlatform.X) return "bi sns-icon bi-twitter-x";
        if (platform === SNSPlatform.TIKTOK) return "bi sns-icon bi-tiktok";
        if (String(url).includes("twitter.com") || String(url).includes("x.com")) return "bi sns-icon bi-twitter-x";
        return "bi sns-icon bi-link-45deg";
    }
}
